import {
  BlockedRecordBlockedType as RawBlockedRecordBlockedType,
  OrderType,
} from '@exam-center/graphql';

import { type DataGridSortDirection } from './types';

export const ORDER_TYPE: Record<DataGridSortDirection, OrderType> = {
  asc: OrderType.Asc,
  desc: OrderType.Desc,
};

export type PickRawBlockedRecordBlockedType = Exclude<
  (typeof RawBlockedRecordBlockedType)[keyof typeof RawBlockedRecordBlockedType],
  RawBlockedRecordBlockedType.Other
>;

export const BLOCKED_TYPE_LABEL_MAP: Record<PickRawBlockedRecordBlockedType, string> = {
  [RawBlockedRecordBlockedType.Instructor]: 'วิทยากร',
  VENDOR: 'Vendor',
  STAFF: 'เจ้าหน้าที่ตลาดหลักทรัพย์',
  MYSTERY_AUDIT: 'ผู้ตรวจสอบ',
  EXAM_CENTER_MANAGER: 'ผู้จัดการศูนย์ทดสอบ',
  PROCTOR_1: 'ผู้คุมสอบประเภทที่ 1',
  PROCTOR_2: 'ผู้คุมสอบประเภทที่ 2',
  PROCTOR_3: 'ผู้คุมสอบประเภทที่ 3',
  CHEATER: 'ผู้ที่ทุจริต',
  EXAM_PASSER: 'ผู้ที่สอบผ่าน',
};

export const ALL_BLOCKED_TYPES = Object.keys(BLOCKED_TYPE_LABEL_MAP) as [
  PickRawBlockedRecordBlockedType,
  ...PickRawBlockedRecordBlockedType[],
];
